module.exports = "/images/XLarge.png?cf737f6ba585c03c01eeffea886daae7";